module.exports = __webpack_public_path__ + "static/ss1.22937d1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/sotonite/ss1.png
// module id = 287
// module chunks = 140298147566112 277036769636407